import React from 'react'
import cx from 'classnames'
import { t } from 'ttag'

import { MessageAlert } from 'components/shared/Alerts/MessageAlert/MessageAlert'
import { Modal } from 'components/shared/Modal/Modal'

import styles from './DeleteResourceModal.module.scss'

export const DeleteResourceModal = ({
  alert,
  className = undefined,
  message,
  title,
  onCancel,
  onClose,
  onConfirm,
  isOpen,
  confirmLabel = undefined,
}) => (
  <Modal
    className={cx(styles.modal, { [className]: Boolean(className) })}
    cancelLabel={t`Go back`}
    confirmLabel={confirmLabel || t`Delete`}
    {...{ title, onCancel, onClose, onConfirm, isOpen }}
  >
    <Modal.Header />
    <Modal.Content className={styles.content}>
      <MessageAlert
        className={styles.alert}
        message={alert}
        variant="warning"
        isInitialised
      />
      <p className={styles.text}>{message}</p>
    </Modal.Content>
    <Modal.Footer />
  </Modal>
)
